<template>
  <div class="homes">
    <el-carousel :interval="5000" arrow="always" :height="bannerHeight + 'px'">
        <el-carousel-item v-for="(item, idnex) in items" :key="idnex">
            <div>
            <img
                :src="item.workpage_image_url"
                alt=""
                ref="bannerHeight"
                @load="imgload"
                width="100%"
            />
            </div>
        </el-carousel-item>
    </el-carousel>

    <!-- 最新作品 -->
    <div class="xinde">
        <span>
            <img :src='this.$guide.url + "/works-display/new.png"' alt="">
            <div>最新作品</div> 
        </span>
        <div class="xin_siodks" id='kuan'>
            <ul class="xin_zuo" ref='sli' id="tlsd" :disabled='disabled'>
                <li class="xin_li" v-for="(zui,index) in zuis" :key="index">
                    <img :src="zui.workpage_new_works_url" alt="" width="100%" @click="zuixin(index)">
                    <p style="font-size: 18px; color: rgb(51, 51, 51);">{{ zui.workpage_new_works_name }}</p>
                    <p style="font-size: 16px; color: rgb(153, 153, 153);">{{ zui.workpage_new_works_time }}</p>
                    <ol class="dian_dongs">
                        <li>
                            <img :src="yushen" alt="" />
                            <p>{{ zui.workpage_new_works_watch                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               }}</p>
                        </li>
                        <li>
                            <img :src="zoushen" alt="" />
                            <p>{{ zui.workpage_new_works_comment }}</p>
                        </li>
                        <li>
                            <img :src="fenshen" alt="" />
                            <p>{{ zui.workpage_new_works_prefer }}</p>
                        </li>
                    </ol>
                    <div class="dangfen">
                        <img :src="zui.workpage_new_works_tiny_logo" alt="">
                        <p>{{ zui.workpage_new_kid_name }}</p>
                    </div>
                    
                </li>
            </ul>
        </div>
        <div class="left_button" @click="left"><img :src='this.$guide.url + "/works-display/left.png"' alt=""></div>
        <div class="right_button" @click="right"><img :src='this.$guide.url + "/works-display/right.png"' alt=""></div>

    </div>
    <!-- 风云榜 -->
    <div class="xindes">
        <span>
            <img :src='this.$guide.url + "/works-display/List.png"' alt="">
            <div>风云榜</div> 
        </span>
        <div class="xin_siodkss">
            <ul class="xin_zuos" ref='slis'>
                <li class="xin_lis" v-for="(feng,indexs) in fengs" :key="indexs">
                        <img :src="feng.rank_works_url" alt="" width="100%" @click="scratchzhan(indexs)">
                    <p style="font-size: 18px; color: rgb(51, 51, 51);">{{ feng.rank_works_name }}</p>
                    <p style="font-size: 16px; color: rgb(153, 153, 153);">{{ feng.rank_works_time }}</p>
                    <ol class="dian_dongss">
                        <li>
                            <img :src="yushen" alt="" />
                            <p>{{ feng.rank_works_watch }}</p>
                        </li>
                        <li>
                            <img :src="zoushen" alt="" />
                            <p>{{ feng.rank_works_comment }}</p>
                        </li>
                        <li>
                            <img :src="fenshen" alt="" />
                            <p>{{ feng.rank_works_prefer }}</p>
                        </li>
                    </ol>
                    <div class="dangfens">
                        <img :src="feng.rank_works_tiny_logo" alt="">
                        <p>{{ feng.rank_kid_name }}</p>
                    </div>
                    
                </li>
            </ul>
        </div>
        <div class="towards_left" @click="left_one"><img :src='this.$guide.url + "/works-display/left.png"' alt=""></div>
        <div class="towards_right" @click="right_two"><img :src='this.$guide.url + "/works-display/right.png"' alt=""></div>
    </div>
    <!-- 全部作品 -->
    <div class="qinfeng">
        <span>
            <p><img :src='this.$guide.url + "/works-display/whole.png"' alt=""></p>
            <div>全部作品</div>
        </span>
        <div class="qin_ya">
            <el-tabs v-model="tabsName" type="card" @tab-click="handleClick">
                <el-tab-pane label="Scratch" name="scratch">
                    <ul class="hanggui">
                        <li class="guili" v-for="(xipin,index) in xipins" :key="index">
                            <div class="zuosi">
                                <div class="tubiaoya">
                                    <img :src="xipin.workpage_works_url" alt="" width="100%" @click="scratchshi(index)">
                                </div>
                                <p style="font-size: 18px; color: rgb(51, 51, 51);">{{ xipin.workpage_works_name }}</p>
                                <p style="font-size: 16px; color: rgb(153, 153, 153);">{{ xipin.workpage_works_time }}</p>
                                <ol class="ci_shu">
                                    <li>
                                        <img :src="yushen" alt="" />
                                        <p>{{ xipin.workpage_works_watch }}</p>
                                    </li>
                                    <li>
                                        <img :src="zoushen" alt="" />
                                        <p>{{ xipin.workpage_works_comment }}</p>
                                    </li>
                                    <li>
                                        <img :src="fenshen" alt="" />
                                        <p>{{ xipin.workpage_works_prefer }}</p>
                                    </li>
                                </ol>
                                <div class="dibu_cont">
                                    <div><img :src="xipin.workpage_works_tiny_logo" alt=""></div>
                                    <p>{{ xipin.workpage_kid_name }}</p>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <el-pagination
                        :current-page.sync="current_page"
                        background
                        layout="prev, pager, next"
                        :total=total
                        :page-size="16"
                    >
                    </el-pagination>
                </el-tab-pane>
                <el-tab-pane label="Python" name="python">
                    <ul class="hanggui">
                        <li class="guili" v-for="(xipin,index) in xipins" :key="index">
                            <div class="zuosi">
                                <div class="tubiaoya"><img :src="xipin.workpage_works_url" alt="" width="100%" @click="pythonzhan(index)"></div>
                                <p style="font-size: 18px; color: rgb(51, 51, 51);">{{ xipin.workpage_works_name }}</p>
                                <p style="font-size: 16px; color: rgb(153, 153, 153);">{{ xipin.workpage_works_time }}</p>
                                <ol class="ci_shu">
                                    <li>
                                        <img :src="yushen" alt="" />
                                        <p>{{ xipin.workpage_works_watch }}</p>
                                    </li>
                                    <li>
                                        <img :src="zoushen" alt="" />
                                        <p>{{ xipin.workpage_works_comment }}</p>
                                    </li>
                                    <li>
                                        <img :src="fenshen" alt="" />
                                        <p>{{ xipin.workpage_works_prefer }}</p>
                                    </li>
                                </ol>
                                <div class="dibu_cont">
                                    <div><img :src="xipin.workpage_works_tiny_logo" alt=""></div>
                                    <p>{{ xipin.workpage_kid_name }}</p>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <el-pagination
                        :current-page.sync="current_page"
                        background
                        layout="prev, pager, next"
                        :total=total
                        :page-size=16
                    >
                    </el-pagination>
                </el-tab-pane>
                <el-tab-pane label="C++" name="cpp">
                    <ul class="hanggui">
                        <li class="guili" v-for="(xipin,index) in xipins" :key="index">
                            <div class="zuosi">
                                <div class="tubiaoya"><img :src="xipin.workpage_works_url" alt="" width="100%" @click="cppzhan(index)"></div>
                                <p style="font-size: 18px; color: rgb(51, 51, 51);">{{ xipin.workpage_works_name }}</p>
                                <p style="font-size: 16px; color: rgb(153, 153, 153);">{{ xipin.workpage_works_time }}</p>
                                <ol class="ci_shu">
                                    <li>
                                        <img :src="yushen" alt="" />
                                        <p>{{ xipin.workpage_works_watch }}</p>
                                    </li>
                                    <li>
                                        <img :src="zoushen" alt="" />
                                        <p>{{ xipin.workpage_works_comment }}</p>
                                    </li>
                                    <li>
                                        <img :src="fenshen" alt="" />
                                        <p>{{ xipin.workpage_works_prefer }}</p>
                                    </li>
                                </ol>
                                <div class="dibu_cont">
                                    <div><img :src="xipin.workpage_works_tiny_logo" alt=""></div>
                                    <p>{{ xipin.workpage_kid_name }}</p>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <el-pagination
                        :current-page.sync="current_page"
                        background
                        layout="prev, pager, next"
                        :total=total
                        :page-size=16
                    >
                    </el-pagination>
                </el-tab-pane>
                <el-tab-pane label="全部作品" name="whole">
                    <ul class="hanggui">
                        <li class="guili" v-for="(xipin,index) in xipins" :key="index">
                            <div class="zuosi">
                                <div class="tubiaoya"><img :src="xipin.workpage_works_url" alt="" width="100%" @click="quanbu(index)"></div>
                                <p style="font-size: 18px; color: rgb(51, 51, 51);">{{ xipin.workpage_works_name }}</p>
                                <p style="font-size: 16px; color: rgb(153, 153, 153);">{{ xipin.workpage_works_time }}</p>
                                <ol class="ci_shu">
                                    <li>
                                        <img :src="yushen" alt="" />
                                        <p>{{ xipin.workpage_works_watch }}</p>
                                    </li>
                                    <li>
                                        <img :src="zoushen" alt="" />
                                        <p>{{ xipin.workpage_works_comment }}</p>
                                    </li>
                                    <li>
                                        <img :src="fenshen" alt="" />
                                        <p>{{ xipin.workpage_works_prefer }}</p>
                                    </li>
                                </ol>
                                <div class="dibu_cont">
                                    <div><img :src="xipin.workpage_works_tiny_logo" alt=""></div>
                                    <p>{{ xipin.workpage_kid_name }}</p>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <el-pagination
                        :current-page.sync="current_page"
                        background
                        layout="prev, pager, next"
                        :total=total
                        :page-size=16
                    >
                    </el-pagination>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import axios from "axios";
export default {
    name: "homes",
    data() {
        return {
            yushen:'',
            zoushen:'',
            fenshen:'',
            bannerHeight: "",
            items: [],
            zuis: [],
            index: 1,
            fengs:[],
            indexs:1,
            xipins:[],
            total:this.total,
            current_page: 1,
            tabsName:'scratch',
            disabled:false
        };
    },
    watch: {
        current_page(to, from) {
            if (from != 0) {
                //搜索分页
                this.inshow(this.tabsName)
            }
        },
    },
    created() {
        this.shen()
        this.infoshow();
        this.inshow(this.tabsName);
        window.addEventListener(
            "resize",
            () => {
                this.bannerHeight = this.$refs.bannerHeight[0].height;
                this.imgload();
            },
            false
        );
        this.autoLoop()
        this.autoLoops()
        // this.jinliang()
        
    },
    mounted() {
        window.scrollTo(0,0);
        this.inshows();
        window.addEventListener("scroll", this.btn_run);
        this.imgload();
        window.addEventListener(
            "resize",
            () => {
                this.bannerHeight = this.$refs.bannerHeight[0].height;
                this.imgload();
            },
            false
        );
    },

    methods: {
        shen(){
            this.yushen = this.$guide.url + "/works-display/kan.png"
            this.zoushen = this.$guide.url + "/works-display/pinlun.png"
            this.fenshen = this.$guide.url + "/works-display/zan.png"
        },
        //轮播图宽高
        imgload() {
            this.$nextTick(() => {
                this.bannerHeight = this.$refs.bannerHeight[0].height;
            });
        },
        //轮播图接口
        infoshow() {
        axios
            .get(this.$guide.api + "/infoshow_work/")
            // 接口地址
            .then((res) => {
             this.items = res.data.context.workpage_list_image;
            });
        },
        
        //最新作品接口
        async inshows() {
            await axios.
            get(this.$guide.api + "/infoshow_work/").then((res) => {
                this.zuis = res.data.context.workpage_list_new;
                this.fengs = res.data.context.workpage_list_rank;                    
            });
           
        },
        //最新作品轮播自动档
        autoLoop(){
            setInterval(()=>{
               this.$refs.sli.style.left = -962+'px' //1205
                this.$refs.sli.style.transition= "all 0.5s"
                this.index++
                if(parseInt(this.$refs.sli.style.left) <= -962 ){
                    setTimeout(()=>{
                        //这个setTimeout是因为left=-600px，transition有0.5s执行动画，需要等它执行完成后，再设置left=0，
                        //否则，直接跳到left=0,动画生硬，
                        this.$refs.sli.style.left = 0 + 'px'
                        this.$refs.sli.style.transition= "all 0s"
                        this.indexs = 1
                    },3000 )
                }
            },3500)
        },
        //最新作品轮播手动档 
        // autoLoop
        left() {
                this.$refs.sli.style.left = -962+'px' //1205
                this.$refs.sli.style.transition= "all 0.5s"
                this.index++
        },
        right() {
                this.$refs.sli.style.left = 0*this.index + 'px' //1205
                this.$refs.sli.style.transition= "all 0.5s"
                this.index--
        },
        // 风云榜作品轮播自动挡
        autoLoops(){
            setInterval(()=>{
                this.$refs.slis.style.left = -962*this.indexs + 'px' //602
                this.$refs.slis.style.transition= "all 0.5s"
                this.indexs++
                if(parseInt(this.$refs.slis.style.left) <= -962 ){
                    setTimeout(()=>{
                        //这个setTimeout是因为left=-600px，transition有0.5s执行动画，需要等它执行完成后，再设置left=0，
                        //否则，直接跳到left=0,动画生硬，
                        this.$refs.slis.style.left = 0 + 'px'
                        this.$refs.slis.style.transition= "all 0s"
                        this.indexs = 1
                    },3500 )
                }
            },4500)
        },
        // 风云榜作品轮播手动挡
        left_one() {
                this.$refs.slis.style.left = -962+'px' //1205
                this.$refs.slis.style.transition= "all 0.5s"
                this.index++
        },
        right_two() {
                this.$refs.slis.style.left = 0*this.index + 'px' //1205
                this.$refs.slis.style.transition= "all 0.5s"
                this.index--
        },
        //增加作品查看次数
        zuixin(e) {
            var he = this.zuis[e];
            var type = 0
            var work_age = he.workpage_new_kid_age                        //年龄
            var work_grade = he.workpage_new_kid_grade                    //班级
            var work_name = he.workpage_new_kid_name                      //作者名字
            var work_studytime = he.workpage_new_kid_studytime            //学习时长
            var work_image_url = he.workpage_new_recommend_image_url      //图片
            var work_code = he.workpage_new_works_code                    //作品文件
            var work_comment = he.workpage_new_works_comment              //评论数量
            var work_id = he.workpage_new_works_id                        //作品id
            var work_logo  = he.workpage_new_works_logo                   //用户logo
            var works_name = he.workpage_new_works_name                   //作品名字
            var work_operating_instructions  = he.workpage_new_works_operating_instructions            //操作说明
            var work_prefer = he.workpage_new_works_prefer   //点赞数量
            var work_remarks = he.workpage_new_works_remarks                 //备注
            var work_sign = he.workpage_new_works_sign           //作品类型
            var works_teaching_id = he.workpage_new_works_teaching_id                      //文件id
            var work_time  = he.workpage_new_works_time            //时间
            var work_tiny_logo = he.workpage_new_works_tiny_logo   //tiny_logo
            var work_url = he.workpage_new_works_url                 //url
            var work_watch  = he.workpage_new_works_watch           //观看次数
            var mduo = 
                {
                    "type":type,"work_age": work_age,"work_grade":work_grade,"work_name":work_name,
                    "work_studytime":work_studytime,"work_image_url":work_image_url,"work_code":work_code,
                    "work_comment":work_comment,"work_id":work_id,"work_logo":work_logo,"works_name":works_name,
                    "work_operating_instructions":work_operating_instructions,"work_prefer":work_prefer,
                    "work_remarks":work_remarks,"work_sign":work_sign,"works_teaching_id":works_teaching_id,
                    "work_time":work_time,"work_tiny_logo":work_tiny_logo,"work_url":work_url,"work_watch":work_watch
                }
            console.log(mduo)
            axios
                .get(
                this.$guide.api + "/infoshow_work_addwatch/?works_id=" +
                    he.workpage_new_works_id
                )
                // 接口地址
                .then((res) => {
                    console.log(res);
                });
                Cookies.set("two", mduo, { expires: 1, path: "/" });
            if(he.workpage_new_works_sign == "python"){
                this.$router.push({ path: "/python_player"});
            } else if(he.workpage_new_works_sign == "cpp"){
                this.$router.push({ path: "/cpp_player"});
            } else if(he.workpage_new_works_sign == "scratch"){
                window.open("scratch3/scratch_player.html")
            }
        },
        //保存数据到cookie
        scratchzhan(o) {
            var yu = this.fengs[o];
            var type = 1
            var work_age = yu.rank_kid_age                        //年龄
            var work_grade = yu.rank_kid_grade                    //班级
            var work_name = yu.rank_kid_name                      //作者名字
            var work_studytime = yu.rank_kid_studytime            //学习时长
            var work_image_url = yu.rank_recommend_image_url      //图片
            var work_code = yu.rank_new_works_code                    //作品文件
            var work_comment = yu.rank_works_comment              //评论数量
            var work_id = yu.rank_works_id                        //作品id
            var work_logo  = yu.rank_works_logo                   //用户logo
            var works_name = yu.rank_works_name                   //作品名字
            var work_operating_instructions = yu.rank_works_operating_instructions            //操作说明
            var work_prefer = yu.rank_works_prefer   //点赞数量
            var work_remarks = yu.rank_works_remarks                 //备注
            var work_sign = yu.rank_works_sign           //作品类型
            var works_teaching_id = yu.rank_works_teaching_id                      //文件id
            var work_time  = yu.rank_works_time            //时间
            var work_tiny_logo = yu.rank_works_tiny_logo   //tiny_logo
            var work_url = yu.rank_works_url                 //url
            var work_watch  = yu.rank_works_watch           //观看次数
            var mduo = {
                "type":type,"work_age": work_age,"work_grade":work_grade,"work_name":work_name,
                "work_studytime":work_studytime,"work_image_url":work_image_url,"work_code":work_code,
                "work_comment":work_comment,"work_id":work_id,"work_logo":work_logo,"works_name":works_name,
                "work_operating_instructions":work_operating_instructions,"work_prefer":work_prefer,
                "work_remarks":work_remarks,"work_sign":work_sign,"works_teaching_id":works_teaching_id,
                "work_time":work_time,"work_tiny_logo":work_tiny_logo,"work_url":work_url,"work_watch":work_watch
            }
            Cookies.set("two", mduo, { expires: 2, path: "/" });
            if(yu.rank_works_sign == "python"){
                this.$router.push({ path: "/python_player"});
                 console.log("我是从风云榜作品跑过来的")
            }else if(yu.rank_works_sign == "cpp"){
                this.$router.push({ path: "/cpp_player"});
                 console.log("我是从风云榜作品跑过来的")
            } else if(yu.rank_works_sign == "scratch"){
                window.open("scratch3/scratch_player.html")
                console.log("我是从风云榜作品跑过来的")
            }
        },
        //分页
        handleClick(e){
            this.tabsNam=e.name
            this.inshow(this.tabsNam)
        },
        //作品分页接口
        inshow(e){
            // console.log(e)
            axios.
                get(this.$guide.api + `/infoshow_work_classification/?work_class=${e}&page_current=${this.current_page}&page_size=16`)
                .then((res) => {
                    this.xipins = res.data.context.current_page_work.page_work_list
                    this.total = res.data.context.summary_work
            });
        },
        // 点击跳转二级页面
        scratchshi(h){
            var two = this.xipins[h];
            console.log(two);
            var type =2
            var work_age = two.workpage_kid_age                        //年龄
            var work_grade = two.workpage_kid_grade                    //班级
            var work_name = two.workpage_kid_name                      //作者名字
            var work_studytime = two.workpage_kid_studytime            //学习时长
            var work_image_url = two.workpage_recommend_image_url      //图片
            var work_code = two.workpage_new_works_code                    //作品文件
            var work_comment = two.workpage_works_comment              //评论数量
            var work_id = two.workpage_works_id                        //作品id
            var work_logo  = two.workpage_works_logo                   //用户logo
            var works_name = two.workpage_works_name                   //作品名字
            var work_operating_instructions = two.workpage_operating_instructions            //操作说明
            var work_prefer = two.workpage_works_prefer   //点赞数量
            var work_remarks = two.workpage_works_remarks                 //备注
            var work_sign = two.workpage_works_sign           //作品类型
            var works_teaching_id = two.workpage_works_teaching_id                      //文件id
            var work_time  = two.workpage_works_time            //时间
            var work_tiny_logo = two.workpage_works_tiny_logo   //tiny_logo
            var work_url = two.workpage_works_url                 //url
            var work_watch  = two.workpage_works_watch           //观看次数
            var mduoads = {
                "type":type,"work_age": work_age,"work_grade":work_grade,"work_name":work_name,
                "work_studytime":work_studytime,"work_image_url":work_image_url,"work_code":work_code,
                "work_comment":work_comment,"work_id":work_id,"work_logo":work_logo,"works_name":works_name,
                "work_operating_instructions":work_operating_instructions,"work_prefer":work_prefer,
                "work_remarks":work_remarks,"work_sign":work_sign,"works_teaching_id":works_teaching_id,
                "work_time":work_time,"work_tiny_logo":work_tiny_logo,"work_url":work_url,"work_watch":work_watch
            }
            Cookies.set("two", mduoads, { expires: 1, path: "/" });
            window.location.href="scratch3/scratch_player.html"
            console.log("我是从全部作品跑过来的")
        },
        pythonzhan(f) {
            var two = this.xipins[f];
            var type=2
            var work_age = two.workpage_kid_age                        //年龄
            var work_grade = two.workpage_kid_grade                    //班级
            var work_name = two.workpage_kid_name                      //作者名字
            var work_studytime = two.workpage_kid_studytime            //学习时长
            var work_image_url = two.workpage_recommend_image_url      //图片
            var work_code = two.workpage_new_works_code                    //作品文件
            var work_comment = two.workpage_works_comment              //评论数量
            var work_id = two.workpage_works_id                        //作品id
            var work_logo  = two.workpage_works_logo                   //用户logo
            var works_name = two.workpage_works_name                   //作品名字
            var work_operating_instructions = two.workpage_operating_instructions            //操作说明
            var work_prefer = two.workpage_works_prefer   //点赞数量
            var work_remarks = two.workpage_works_remarks                 //备注
            var work_sign = two.workpage_works_sign           //作品类型
            var works_teaching_id = two.workpage_works_teaching_id                      //文件id
            var work_time  = two.workpage_works_time            //时间
            var work_tiny_logo = two.workpage_works_tiny_logo   //tiny_logo
            var work_url = two.workpage_works_url                 //url
            var work_watch  = two.workpage_works_watch           //观看次数
            var mduoa = {
                "type":type,"work_age": work_age,"work_grade":work_grade,"work_name":work_name,
                "work_studytime":work_studytime,"work_image_url":work_image_url,"work_code":work_code,
                "work_comment":work_comment,"work_id":work_id,"work_logo":work_logo,"works_name":works_name,
                "work_operating_instructions":work_operating_instructions,"work_prefer":work_prefer,
                "work_remarks":work_remarks,"work_sign":work_sign,"works_teaching_id":works_teaching_id,
                "work_time":work_time,"work_tiny_logo":work_tiny_logo,"work_url":work_url,"work_watch":work_watch
            }
            Cookies.set("two", mduoa, { expires: 1, path: "/" });
            this.$router.push({ path: "/python_player"});
            console.log("我是从全部作品跑过来的")
        },
        cppzhan(x){
            var two= this.xipins[x];
            var type=2
            var work_age = two.workpage_kid_age                        //年龄
            var work_grade = two.workpage_kid_grade                    //班级
            var work_name = two.workpage_kid_name                      //作者名字
            var work_studytime = two.workpage_kid_studytime            //学习时长
            var work_image_url = two.workpage_recommend_image_url      //图片
            var work_code = two.workpage_new_works_code                    //作品文件
            var work_comment = two.workpage_works_comment              //评论数量
            var work_id = two.workpage_works_id                        //作品id
            var work_logo  = two.workpage_works_logo                   //用户logo
            var works_name = two.workpage_works_name                   //作品名字
            var work_operating_instructions = two.workpage_operating_instructions            //操作说明
            var work_prefer = two.workpage_works_prefer   //点赞数量
            var work_remarks = two.workpage_works_remarks                 //备注
            var work_sign = two.workpage_works_sign           //作品类型
            var works_teaching_id = two.workpage_works_teaching_id                      //文件id
            var work_time  = two.workpage_works_time            //时间
            var work_tiny_logo = two.workpage_works_tiny_logo   //tiny_logo
            var work_url = two.workpage_works_url                 //url
            var work_watch  = two.workpage_works_watch           //观看次数
            var mduoas = {
                "type":type,"work_age": work_age,"work_grade":work_grade,"work_name":work_name,
                "work_studytime":work_studytime,"work_image_url":work_image_url,"work_code":work_code,
                "work_comment":work_comment,"work_id":work_id,"work_logo":work_logo,"works_name":works_name,
                "work_operating_instructions":work_operating_instructions,"work_prefer":work_prefer,
                "work_remarks":work_remarks,"work_sign":work_sign,"works_teaching_id":works_teaching_id,
                "work_time":work_time,"work_tiny_logo":work_tiny_logo,"work_url":work_url,"work_watch":work_watch
            }
            Cookies.set("two", mduoas, { expires: 1, path: "/" });
            this.$router.push({ path: "/cpp_player"});
            console.log("我是从全部作品跑过来的")
        },
         quanbu(d) {
            var two = this.xipins[d];
            var type=2
            var work_age = two.workpage_kid_age                        //年龄
            var work_grade = two.workpage_kid_grade                    //班级
            var work_name = two.workpage_kid_name                      //作者名字
            var work_studytime = two.workpage_kid_studytime            //学习时长
            var work_image_url = two.workpage_recommend_image_url      //图片
            var work_code = two.workpage_new_works_code                    //作品文件
            var work_comment = two.workpage_works_comment              //评论数量
            var work_id = two.workpage_works_id                        //作品id
            var work_logo  = two.workpage_works_logo                   //用户logo
            var works_name = two.workpage_works_name                   //作品名字
            var work_operating_instructions = two.workpage_operating_instructions            //操作说明
            var work_prefer = two.workpage_works_prefer   //点赞数量
            var work_remarks = two.workpage_works_remarks                 //备注
            var work_sign = two.workpage_works_sign           //作品类型
            var works_teaching_id = two.workpage_works_teaching_id                      //文件id
            var work_time  = two.workpage_works_time            //时间
            var work_tiny_logo = two.workpage_works_tiny_logo   //tiny_logo
            var work_url = two.workpage_works_url                 //url
            var work_watch  = two.workpage_works_watch           //观看次数
            var mdu = {
                "type":type,"work_age": work_age,"work_grade":work_grade,"work_name":work_name,
                "work_studytime":work_studytime,"work_image_url":work_image_url,"work_code":work_code,
                "work_comment":work_comment,"work_id":work_id,"work_logo":work_logo,"works_name":works_name,
                "work_operating_instructions":work_operating_instructions,"work_prefer":work_prefer,
                "work_remarks":work_remarks,"work_sign":work_sign,"works_teaching_id":works_teaching_id,
                "work_time":work_time,"work_tiny_logo":work_tiny_logo,"work_url":work_url,"work_watch":work_watch
            }
            Cookies.set("two", mdu, { expires: 1, path: "/" });
            console.log(two.workpage_works_sign)
            if(two.workpage_works_sign == "python"){
                this.$router.push({ path: "/python_player"});
                console.log("我是从全部作品跑过来的")
            }else if(two.workpage_works_sign == "cpp"){
                this.$router.push({ path: "/cpp_player"});
                console.log("我是从全部作品跑过来的")
            } else if(two.workpage_works_sign){
                window.open("scratch3/scratch_player.html")
                console.log("我是从全部作品跑过来的")
            }
        },
    },
};
</script>

<style>
*{
    margin: 0;
    padding: 0;
}
.homes {
  width: 100%;
  height: auto;
  position: relative;
  top: 100px;
  left: 0;
  font-family: "微软雅黑";
}
/* 最新作品样式 */
.xinde{
    width: 62.5%;
    height: 500px;
    margin-top: 100px;
    margin-left: 20%;
    position: relative;
}
.xinde span{
    display: inline-block;
    height: 50px;
    position: absolute;
    left: 0px;
}
.xinde span img{
    position: absolute;
    left: 0px;
}
.xinde span div{
    font-size: 24px;
    margin-left: 60px;
    margin-top: 10px;
}
.xin_siodks{
    width: 100%;
    height: 370px;
    border: 1px solid gainsboro;
    border-radius: 10px;
    overflow: hidden;
    position: relative;
    top: 100px;
}
.xin_zuo {
    width: 201.5%;
    height: 370px !important;
    left: 0px;
    position: absolute;
    display: flex;
    flex-wrap: nowrap;
    list-style: none;
}
 .xin_li {
    width: 25%;
    height: 370px;/* ; 420 */
    border: 1px solid gainsboro;
    margin-left: 12px;
}
.xin_li img{
    cursor: pointer;
}
.xin_zuo .xin_li:nth-child(1){
    margin-left: 0px;
}
.xin_zuo .xin_li:nth-child(5){
    margin-left: 0px;
}
.xin_li>p{
    text-align: left;
    font-size: 18px;
    margin-left: 20px;
    margin-top: 20px;
}
.xin_li .dian_dongs{
    list-style: none;
    width: 100%;
    height: 50px;
    margin-top: 5px;
    display: flex;
    flex-wrap: wrap;
}
.xin_li .dian_dongs li {
  width: 33%;
  height: 50px;
}
.xin_li .dian_dongs li img {
  position: relative;
  margin-top: 15px;
  margin-left: -20px;
}
.dian_dongs li p {
  /* width: 20px;
  height: 20px; */
  margin-top: -23px;
  margin-left: 43px;
}
.dangfen{
    width: 100%;
    height: 40px;
    border-top: 1px solid gainsboro;
}
.dangfen>img{
 margin-left: -190px;
 margin-top: 5px;
}
.dangfen p{
    margin-top: -25px;
    margin-left: -70px;
}

/* 风云榜样式 */
.xindes{
    width: 62.5%;
    height: 500px;
    /* border: 1px solid red; */
    margin-top: 60px;
    margin-left: 20%;
    position: relative;
}
.xindes span{
    display: inline-block;
    height: 50px;
    position: absolute;
    left: 0px;
}
.xindes span img{
    position: absolute;
    left: 0px;
}
.xindes span div{
    font-size: 24px;
    margin-left: 70px;
    margin-top: 10px;
}
.xin_siodkss{
    width: 100%;
    height: 370px;
    border: 1px solid gainsboro;
    border-radius: 10px;
    overflow: hidden;
    position: relative;
    top: 100px;
}
.xin_zuos {
    width: 201.5%;
    height: 370px !important;
    left: 0px;
    position: absolute;
    display: flex;
    flex-wrap: nowrap;
    list-style: none;
}
 .xin_lis {
    width: 25%;
    height: 370px;
    border: 1px solid gainsboro;
    margin-left: 12px;
}
.xin_lis img{
    cursor: pointer;
}
.xin_zuos .xin_lis:nth-child(1){
    margin-left: 0px;
}
.xin_zuos .xin_lis:nth-child(5){
    margin-left: 0px;
}
.xin_lis>p{
    text-align: left;
    font-size: 18px;
    margin-left: 20px;
    margin-top: 20px;
}
.xin_lis .dian_dongss{
    list-style: none;
    width: 100%;
    height: 50px;
    margin-top: 5px;
    display: flex;
    flex-wrap: wrap;
}
.xin_lis .dian_dongss li {
  width: 33%;
  height: 50px;
}
.xin_lis .dian_dongss li img {
  position: relative;
  margin-top: 15px;
  margin-left: -20px;
}
.dian_dongss li p {
  /* width: 20px;
  height: 20px; */
  margin-top: -23px;
  margin-left: 43px;
}
.dangfens{
    width: 100%;
    height: 40px;
    border-top: 1px solid gainsboro;
    /* overflow: hidden; */
}
.dangfens>img{
 margin-left: -190px;
 margin-top: 5px;
}
.dangfens p{
    margin-top: -25px;
    margin-left: -70px;
}

/* 全部作品样式 */
.qinfeng{
    width: 62.5%;
    height: auto;
    /* border: 1px solid red; */
    margin-left: 20%;
    margin-top: 50px;
    position: relative;
}
.qinfeng span{
    display: inline-block;
    height: 50px;
    margin-top: 50px;
}
.qinfeng span p{
    width: 51px;
    height: 50px;
    position: absolute;
    left: 0px;
}
.qinfeng span div{
    font-size: 24px;
    position: absolute;
    left: 70px;
    margin-top: 10px;
    text-align: left;
}
.qin_ya{
    width: 100%;
    height: auto;
    margin-top: -60px;
}
.qin_ya .el-tabs__nav{
    border: 0px !important;
}
.qin_ya .el-tabs--card>.el-tabs__header{
    border: 0px !important;
}
.hanggui{
    width: 100%;
    height: auto;
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    margin-left: -11px;
}
.guili{
    width: 23%;
    height: 25%;
    margin-left: 15px;
    margin-top: 50px;
}
.zuosi{
    width: 100%;
    height: 100%;
    /* border: 1px solid black; */
    box-shadow: 0px 2px 15px 5px rgba(144,170,179,0.22);
    border-radius: 10px;
}
.zuosi .tubiaoya{
    width: 100%;
}
.zuosi .tubiaoya img{
    /* border-radius: 10px; */
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
    cursor: pointer;
}
.zuosi>p{
    margin-top: 20px;
    margin-left: 10px;
    text-align: left;
}
.zuosi .ci_shu{
    width: 100%;
    height: 50px;
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    margin-top: 10px;
}
.zuosi .ci_shu li{
    width: 30%;
    height: 50px;
}
.zuosi .ci_shu li img {
  margin-top: 15px;
  margin-left: -40px;
}
.zuosi .ci_shu li p {
  margin-top: -23px;
  margin-left: 25px;
}
.dibu_cont{
    width: 100%;
    height: 50px;
    border-top: 1px solid gainsboro;
}
.dibu_cont div{
    width: 50px;
    height: 50px;
}
.dibu_cont div img{
    margin-top: 10px;
}
.dibu_cont p{
    margin-top: -33px;
    margin-left: -40%;
}
/* 分页器样式 */
.el-pagination{
    margin-top: 50px;
}
.left_button{
    width: 30px;
    height: 50px;
    position: absolute;
    border: 0px;
    color: white;
    right: 7%;
    top: 50px;
    cursor: pointer;
}
.right_button{
    width: 30px;
    height: 50px;
    position: absolute;
    border: 0px;
    color: white;
    right: 1%;
    top: 50px;
    cursor: pointer;
}
.towards_left{
    width: 30px;
    height: 50px;
    border: 0px;
    color: white;
    position: absolute;
    right: 7%;
    top: 50px;
    cursor: pointer;
}
.towards_right{
    width: 30px;
    height: 50px;
    border: 0px;
    color: white;
    position: absolute;
    right: 1%;
    top: 50px;
    cursor: pointer;
}
.homes .el-tabs__item{
    width: 120px;
    height: 45px;
    border: 1px solid grey!important;
    border-radius: 30px;
    text-align: center!important;
    line-height: 45px;
    font-size: 16px!important;
    margin-left: 30px!important;
    color: #666;
    margin-top: 5px!important;
}
.homes .el-tabs__nav {
    height: 50px;
    margin-left: 45%!important;
}
.is-active{
    color: cornflowerblue !important;
}
/*  */
</style>
